import axios from 'axios';

function loadMore(e, container) {
  e.preventDefault();
  const button = e.target;
  const text = button.textContent;

  let queryArgs = JSON.parse(button.dataset.queryArgs);
  queryArgs = { ...queryArgs, paged: queryArgs.paged ? queryArgs.paged + 1 : 2}


  let params = new URLSearchParams();
  params.append('action', 'load_more');
  params.append('query_args', encodeURIComponent(JSON.stringify(queryArgs)));


  /**
   * Update button to "waiting state"
   */
  button.textContent = button.dataset.loadLabel;
  button.setAttribute('disabled', '');

  // eslint-disable-next-line no-undef
  axios.post(`${ajaxURL}`, params)
    .then((res) => {
      container.innerHTML += res.data.data;

      /**
       * Update window.location
       */
      const getUrl = window.location;
      const baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
      const basePathName = getUrl.pathname.split('page/')[0].slice(1);
      window.history.pushState('', '', `${baseUrl}${basePathName}page/${queryArgs.paged}`);

      /**
       * Remove button if we reach the max post number
       * else remove "waiting state" and update data-attributes
       */
      if (queryArgs.paged >= button.dataset.maxNumPages) {
        button.parentNode.removeChild(button);
      } else {
        button.textContent = text;
        button.dataset.queryArgs = JSON.stringify(queryArgs);
        button.removeAttribute('disabled');
      }
    })
    .catch((err) => {
      // Error Message
      console.log(err);
      const errorMsg = document.createElement('div');
      errorMsg.textContent = 'Something went wrong. Please reload the page and try again later';
      container.append(errorMsg);
      button.parentNode.removeChild(button);
    })
}

function init() {
    const loadMoreButtonList = document.querySelectorAll('.js-load-more');
    Array.from(loadMoreButtonList).forEach(button => {
      const container = document.getElementById(button.dataset.containerId);
      button.addEventListener('click', e => { loadMore(e, container) });
    });
}

export default { init }
